import * as ko from "knockout";
import { BaseCrop } from "../Models/Crops/BaseCrop";

export class CropActiveYearViewModel<T extends BaseCrop> {
    allActiveCrops = ko.observableArray<T>();
    isLoading = ko.observable<boolean>(true);
}